import { OnboardingStepFooter } from "@/features/onboarding/components/OnboardingStepFooter";
import { formComponents as fc } from "@/features/i18n/formComponents";
import { Form } from "@patient-watch/ui/form";
import { useForm } from "@/utils/form";
import { useProfileCopy } from "@/features/i18n/profileCopy";
import { useMessageHistoryCopy } from "@/features/i18n/messageHistoryCopy";
import { usePreferencesMutation } from "../api/preferencesMutation";
import { usePreferencesQuery } from "../api/preferencesQuery";
import NotificationsDisabledAlert from "./NotificationsDisabledAlert";

interface Props {
    onSuccess?: () => void;
    onBack?: () => void;
    isDialog?: boolean;
    isDemo?: boolean;
    demoDefaults?: {
        email?: boolean;
        sms?: boolean;
    };
}

export default function PreferencesForm({ onSuccess, onBack, isDialog = true, isDemo = false, demoDefaults }: Props) {
    const copy = useProfileCopy();
    const messageCopy = useMessageHistoryCopy();
    const { data: preferences } = usePreferencesQuery();
    const updatePreferences = usePreferencesMutation();

    const form = useForm({
        defaultValues: {
            email: demoDefaults?.email ?? preferences?.channel_types?.email ?? true,
            sms: demoDefaults?.sms ?? preferences?.channel_types?.sms ?? true,
        },
    });

    const onSubmit = async (data) => {
        if (isDemo) {
            onSuccess?.();
            return;
        }

        await updatePreferences.mutateAsync(data);
        onSuccess?.();
    };

    const email = form.watch("email");
    const sms = form.watch("sms");

    return (
        <Form {...form}>
            {!isDialog ? (
                <div className="space-y-1">
                    <h2 className="font-semibold text-lg">{copy.notificationPreferences}</h2>
                    <p className="text-muted-foreground text-sm">{copy.notificationPreferencesDescription}</p>
                </div>
            ) : null}
            <NotificationsDisabledAlert isVisible={!email && !sms} />
            <form className="form" onSubmit={form.handleSubmit(onSubmit)}>
                <div className="space-y-4 bg-white p-4 border border-slate-200 rounded-lg">
                    <fc.Switch autoFocus={true} name="email" label={messageCopy.channelEmail} />
                    <fc.Switch name="sms" label={messageCopy.channelSms} />
                </div>
                {isDialog ? (
                    <fc.SaveButton isDialog isLoading={!isDemo && updatePreferences.isPending} />
                ) : (
                    <OnboardingStepFooter onBack={onBack} isLoading={!isDemo && updatePreferences.isPending} />
                )}
            </form>
        </Form>
    );
}
